// extracted by mini-css-extract-plugin
export default {"buttons":"render-expiration-date_buttons__k915o","extendTime":"render-expiration-date_extendTime__I-a1W"};